import React, { useState, useEffect } from 'react';
import ModalCreateUser from '../components/ModalCreateUser';
import ModalCreateRole from '../components/ModalCreateRole';
import ModalCreateState from '../components/ModalCreateState';
import { useUserContext } from '../context/UserContext';
import { useStatusContext } from '../context/StatusContext';
import { useRolesContext } from '../context/RolesContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserPlus, faShieldHalved, faTag, faPen, faUser, faShield, faCircle } from '@fortawesome/free-solid-svg-icons';

const COLUMNS = { users: 'Пользователи', roles: 'Роли', status: 'Состояния' };

const COLUMN_ICONS = {
  users: faUser,
  roles: faShield,
  status: faCircle,
};

const AdminPage = () => {
  const { users } = useUserContext();
  const { roles } = useRolesContext();
  const { status } = useStatusContext();
  const [selectedTask, setSelectedTask] = useState(null);
  const [isModalUserOpen, setIsModalUserOpen] = useState(false);
  const [isModalRoleOpen, setIsModalRoleOpen] = useState(false);
  const [isModalStateOpen, setIsModalStateOpen] = useState(false);
  const [objects, setObjects] = useState({});

  useEffect(() => {
    setObjects({ users, roles, status });
  }, [status, users, roles]);

  const openModal = (item, col) => {
    setSelectedTask(item);
    if (col === 'users') setIsModalUserOpen(true);
    else if (col === 'roles') setIsModalRoleOpen(true);
    else if (col === 'status') setIsModalStateOpen(true);
  };

  const closeModal = () => {
    setSelectedTask(null);
    setIsModalUserOpen(false);
    setIsModalRoleOpen(false);
    setIsModalStateOpen(false);
  };

  const formatRoleName = (roleId) => {
    const found = roles?.find(r => r._id === roleId);
    return found ? found.ruName || found.name : '—';
  };

  return (
    <div className="crm-page">
      {/* Breadcrumb */}
      <div className="crm-breadcrumb">
        <span className="crm-breadcrumb__item">Рабочий стол</span>
        <span className="crm-breadcrumb__sep">›</span>
        <span className="crm-breadcrumb__item crm-breadcrumb__item--active">Администрирование</span>
      </div>

      {/* Заголовок + кнопки */}
      <div className="crm-page-header">
        <h1 className="crm-page-title">Администрирование</h1>
        <div className="admin-header-actions">
          <button className="admin-add-btn" onClick={() => openModal(null, 'users')}>
            <FontAwesomeIcon icon={faUserPlus} />
            <span>Пользователь</span>
          </button>
          <button className="admin-add-btn" onClick={() => openModal(null, 'roles')}>
            <FontAwesomeIcon icon={faShieldHalved} />
            <span>Роль</span>
          </button>
          <button className="admin-add-btn" onClick={() => openModal(null, 'status')}>
            <FontAwesomeIcon icon={faTag} />
            <span>Состояние</span>
          </button>
        </div>
      </div>

      {/* Три колонки */}
      <div className="admin-columns">
        {Object.keys(COLUMNS).map(columnId => (
          <div key={columnId} className="admin-column">
            <div className="admin-column__header">
              <FontAwesomeIcon icon={COLUMN_ICONS[columnId]} className="admin-column__icon" />
              <span className="admin-column__title">{COLUMNS[columnId]}</span>
              <span className="admin-column__count">{objects[columnId]?.length ?? 0}</span>
            </div>

            <div className="admin-column__body">
              {objects[columnId]?.map(object => (
                <div
                  key={object._id}
                  className="admin-item"
                  onClick={() => openModal(object, columnId)}
                >
                  <div className="admin-item__main">
                    <span className="admin-item__name">{object.name}</span>
                    <FontAwesomeIcon icon={faPen} className="admin-item__edit" />
                  </div>

                  {columnId === 'users' && (
                    <div className="admin-item__meta">
                      <span className="admin-item__badge">{formatRoleName(object.role)}</span>
                      {object.comment && <span className="admin-item__comment">{object.comment}</span>}
                    </div>
                  )}

                  {columnId === 'roles' && (
                    <div className="admin-item__meta">
                      <span className="admin-item__badge">{object.type}</span>
                      {object.ruName && <span className="admin-item__comment">{object.ruName}</span>}
                    </div>
                  )}

                  {columnId === 'status' && object.color && (
                    <div className="admin-item__meta">
                      <span
                        className="admin-item__color-dot"
                        style={{ background: object.color }}
                      />
                      <span className="admin-item__comment">{object.color}</span>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      {isModalUserOpen && <ModalCreateUser object={selectedTask} onClose={closeModal} />}
      {isModalRoleOpen && <ModalCreateRole object={selectedTask} onClose={closeModal} />}
      {isModalStateOpen && <ModalCreateState object={selectedTask} onClose={closeModal} />}
    </div>
  );
};

export default AdminPage;